import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const idr = (n) => {
  const num = Number(n || 0);
  return "Rp " + num.toLocaleString("id-ID");
};

// Format URL media/gambar relatif menjadi URL backend utuh
export const formatMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    return url;
  }
  const cleanPath = url.startsWith("/api") ? url.replace(/^\/api/, "") : url;
  return `${API_BASE}${cleanPath.startsWith("/") ? "" : "/"}${cleanPath}`;
};
// yang aman untuk toast. Mencegah crash "Objects are not valid as a React child"
// saat toast menerima object/array (mis. 422 validation errors).
export const detailText = (detail) => {
  if (typeof detail === "string") return detail.trim() || undefined;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (d && typeof d.msg === "string") {
          const loc = Array.isArray(d.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
          return loc ? `${loc}: ${d.msg}` : d.msg;
        }
        return "";
      })
      .filter(Boolean);
    return parts.length ? parts.join("; ") : undefined;
  }
  if (detail && typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return undefined;
};
